import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "NOTICE_TIME",
    applicationRights: Rights,
    title: 'Varslingstid',
    text: 'Varslingstid',
    icon: 'alarm',
    showOnDashboardByDefault: false,
    url: "/noticetime",
    sequenceNo: 9000,
    routes: Routes
})
